import React from "react";
import SiteLayout from "../components/SiteLayout";
import { studioPolicies } from "../siteContent";

const Terms = () => {
  return (
    <SiteLayout>
      <section className="page-hero page-hero--compact">
        <div className="container">
          <p className="section-eyebrow">Policies</p>
          <h1>Studio policies and consultation guidance</h1>
          <p className="lead">
            Clear expectations help every grey transition and colour analysis
            journey feel calm, premium, and well supported.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="policy-card">
            {studioPolicies.map((policy) => (
              <p key={policy}>{policy}</p>
            ))}
          </div>
        </div>
      </section>
    </SiteLayout>
  );
};

export default Terms;
